import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext';
import type { OperationalUnitCode } from './types';

export function UnitAccessRoute({
  children,
  unitCode,
}: {
  children: ReactNode;
  unitCode: OperationalUnitCode;
}) {
  const { user } = useAuth();

  if (!user?.unitCodes.includes(unitCode)) {
    return <Navigate to="/enote" replace />;
  }

  return children;
}
